import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { receivePickupTypeSelection } from '../../actions/pickupAddon';
import ButtonGroup from '../ButtonGroup';

export const mapStateToProps = ({
  language,
  pickupAddon: { options: { pickupTypes = [] } = {}, form: { pickupType = null } = {} },
  returnsSettings: {
    pickups: { features: { pickupOptions: { disable: disablePickupOptions = [] } = {} } = {} } = {},
  } = {},
}) => ({
  language,
  allOptions: pickupTypes,
  selected: pickupType,
  disablePickupOptions,
});

const PickupTypes = ({ dispatch, language, allOptions, selected, disablePickupOptions }) => {
  const options = allOptions
    .filter((e) => !disablePickupOptions.includes(e))
    .map((id) => ({
      id,
      label: language[`returns.pickups_page.pickup_types.${id.toLowerCase()}`] || id,
      selected: id === selected,
    }));

  if (!options.length) return null;

  return (
    <div>
      <strong>{language['returns.pickups_page.pickup_types.title']}</strong>
      <div style={{ marginTop: '1rem' }}>
        <ButtonGroup
          options={options}
          onClick={({ id }) => dispatch(receivePickupTypeSelection(id))}
        />
      </div>
    </div>
  );
};

PickupTypes.defaultProps = {
  allOptions: [],
  selected: null,
  disablePickupOptions: [],
};

PickupTypes.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  allOptions: PropTypes.arrayOf(PropTypes.string),
  selected: PropTypes.string,
  disablePickupOptions: PropTypes.arrayOf(PropTypes.string),
};

export default connect(mapStateToProps)(PickupTypes);
